import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n';
import { GlobeIcon } from './icons';

export default function LanguageSwitch() {
  const { locale, t } = useI18n();
  const location = useLocation();

  // Calculate the target URL for language switch
  const getTargetUrl = () => {
    const currentPath = location.pathname;
    const currentSearch = location.search;

    if (locale === 'zh') {
      // Switch to English
      return `/en${currentPath}${currentSearch}`;
    } else {
      // Switch to Chinese - remove /en prefix
      const newPath = currentPath.replace(/^\/en/, '') || '/';
      return `${newPath}${currentSearch}`;
    }
  };

  return (
    <Link
      to={getTargetUrl()}
      className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
      title={t.language.switch}
    >
      <GlobeIcon className="w-4 h-4" />
      <span>{locale === 'zh' ? 'English' : '中文'}</span>
    </Link>
  );
}
